// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"180":"video","303":"widget","495":"feed"}[chunkId] + "." + {"180":"41e489c78ac38bbeb2d3","303":"f3be9ccb974865441421","495":"f9c572511bfa2fb4010a"}[chunkId] + ".js";
};